import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { UpdateSiteLeadData } from '.';
import { APPCONFIG } from '@config/app.config';
import useSiteLeadStore from '@store/siteLeadStore';

export const useGetSiteLeadQuery = (): IQueryResponse<UpdateSiteLeadData> => {
	const { siteId } = useSiteLeadStore();

	const getSiteLeadData = async (): Promise<UpdateSiteLeadData> => {
		const url = `${APPCONFIG.baseUrl}${APPCONFIG.apiVersion}/site-leads/wwa/site-lead/${siteId}/update_site_lead/`;
		return await APIService.getData<UpdateSiteLeadData>(url);
	};
	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['siteLeadData'],
		queryFn: getSiteLeadData,
		enabled: !!siteId,
		refetchOnWindowFocus: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
